import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/web/routes/-legal/LegalPage";
import disclosuresHtml from "@/web/routes/-legal/disclosures.md?html";
import { appUrl } from "@/web/lib/siteUrls";

const DESCRIPTION = "Important disclosures for WITH.CO.";

export const Route = createFileRoute("/disclosures")({
  ssr: true,
  head: () => ({
    meta: [
      { title: "Disclosures — WITH.CO" },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: "Disclosures — WITH.CO" },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: appUrl("/disclosures") },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => <LegalPage title="Disclosures" html={disclosuresHtml} />,
});
